(() => {
  const match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
  if (!match) return;

  const routesRoot = window.Shopify?.routes?.root || '/';
  const handle = decodeURIComponent(match[1]);

  fetch(`${routesRoot}products/${encodeURIComponent(handle)}.js`)
    .then((response) => (response.ok ? response.json() : null))
    .then((freshProduct) => {
      const freshTitle = freshProduct?.title?.trim();
      if (!freshTitle) return;

      const heading = document.querySelector('[data-testid="product-information"] h1');
      const staleTitle = heading?.textContent.trim() || '';

      if (heading) {
        heading.textContent = freshTitle;
        heading.dataset.productTitleSynced = 'true';
      }

      document.querySelectorAll('[data-testid="sticky-product-title"]').forEach((element) => {
        element.textContent = freshTitle;
      });

      if (staleTitle && document.title.includes(staleTitle)) {
        document.title = document.title.replace(staleTitle, freshTitle);
      }
    })
    .catch(() => {});
})();
